import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl } from "./services";

const UpdatePassword = () => {
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");

  let PEmail = localStorage.getItem("ForgotPasswordEmail");

  const UserLogin = async () => {
    if (Email === "" || Email == null) {
      alert("PLease Enter Email Address");
    } else if (Password === "" || Password == null) {
      alert("PLease Enter Password");
    } else if (Email !== Password) {
      alert("Password not Matched");
    } else {
      var obj = {
        Email: PEmail,
        Password: Password,
      };
      axios.post(MyApiUrl + "UpdatePassword", obj).then((response) => {
        if (response.data) {
          alert("Login Password Changed, Please Login");
          localStorage.setItem("ForgotPasswordEmail", null);
          window.location.href = "/";
        } else {
          alert("Failed!");
        }
      });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="login-account">
          <div className="row h-100">
            <div className="col-lg-8 align-self-start m-b30">
              <div
                className="account-info-area"
                style={{
                  backgroundImage: "url(assets/images/pattern/bg-pattern1.png)",
                }}
              >
                <div className="row h-100 align-items-center">
                  <div className="col-xl-12 col-md-12 col-sm-12">
                    <img
                      style={{ width: "100%" }}
                      alt="Img"
                      src="assets/images/logo/Logo.jpg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-7 col-sm-8 mx-auto align-self-center">
              <div className="login-form">
                <div className="login-head">
                  <h3 className="title">Change Password</h3>
                  {/* <p>Lorem ipsum dolor sit amet consectetur adipiscing</p> */}
                </div>
                <h6 className="login-title">
                  <span>Forgot Password</span>
                </h6>
                <form className="form" method="POST" action="#">
                  <div className="form-group m-b30">
                    <label className="form-label text-secondary">
                      New Password
                    </label>
                    <div className="input-group input-line">
                      <input
                        name="dzEmail"
                        required
                        type="text"
                        className="form-control"
                        placeholder="************"
                        value={Email}
                        onChange={(event) => {
                          setEmail(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group m-b30">
                    <label className="form-label text-secondary">
                      Confirm Password
                    </label>
                    <div className="secure-input input-line">
                      <input
                        type="password"
                        name="password"
                        className="form-control dz-password"
                        placeholder="*************"
                        value={Password}
                        onChange={(event) => {
                          setPassword(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <button
                    name="submit"
                    type="button"
                    value="Submit"
                    onClick={UserLogin}
                    className="btn btn-secondary shadow-secondary w-100"
                  >
                    Update Password
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UpdatePassword;
